import { render, staticRenderFns } from "./other-party-tab.vue?vue&type=template&id=40ead78d&scoped=true&"
import script from "./other-party-tab.vue?vue&type=script&lang=js&"
export * from "./other-party-tab.vue?vue&type=script&lang=js&"
import style0 from "./other-party-tab.vue?vue&type=style&index=0&id=40ead78d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ead78d",
  null
  
)

export default component.exports